import DismissBanner from '@zenbusiness/zui/DismissBanner';
import { superstyled } from '@zenbusiness/zui/styles';

export const Banner = superstyled({
  name: 'BillingBackupCardBanner',
  slot: 'Banner',
  tag: DismissBanner,
  styles: ({ theme }) => ({
    marginBlockEnd: theme.spacing(4),
  }),
});
